import { useMutation } from "@tanstack/react-query";
import { t } from "ttag";

import { downloadPdf } from "@/shared/api";
import { useToastStore } from "@/shared/ui";

export const useDownloadPdf = () => {
  const pushToast = useToastStore.getState().pushToast;

  return useMutation({
    mutationFn: downloadPdf,
    onError: () => {
      void pushToast({
        type: "error",
        title: t`Error`,
        message: t`The order is not ready yet, please try again later or contact support`,
      });
    },
  });
};
